import Skeleton from "react-loading-skeleton";

interface PackRemainingCountProps {
  currentCount: number | null | undefined;
  loading: boolean;
}

const PackRemainingCount = ({
  currentCount,
  loading,
}: PackRemainingCountProps) => (
  <div className="w-full p-5 h-auto flex justify-between items-center bg-white">
    {loading ? (
      <Skeleton style={{ height: 20, width: 100 }} />
    ) : (
      <>
        <div className="text-black text-lg font-semibold">남은 개수</div>
        <div className="text-black text-lg font-bold">
          {currentCount ?? 0}개
        </div>
      </>
    )}
  </div>
);

export default PackRemainingCount;
